import { ColoredLinearProgress } from './linear-progress';
import React from 'react';

export const ActivityIndicator = (props: { activityInProgress: boolean }) => {
  return props.activityInProgress ? <ColoredLinearProgress /> : null;
};
